export default __webpack_public_path__ + "static/media/seo.ee95ee57.jpg";